import React, { useLayoutEffect } from 'react'
import { Helmet } from 'react-helmet'

import { Intro } from './intro'
import { Questions } from './questions'
import { AskAndCta } from './ask-cta'

// /faqs, rebuilt on the design system the home page and /services moved onto
// on 4 and 5 October 2026. Read client/gwmc/DESIGN.md before touching any of
// it.
//
// This file is a running order and nothing else, the way
// pages/home/home-page.jsx and pages/services/index.js are. One section is
// one directory and one job, each owning its own markup, copy and
// stylesheet.
//
//   section      directory      band             job
//   ----------------------------------------------------------------------
//   Intro        ./intro/       paper            the H1, the promise, the facts line
//   Questions    ./questions/   paper/stone/paper  the seventeen answers, in three groups
//   AskAndCta    ./ask-cta/     stone, paper     the two ways to ask, then the one button
//
// Bands run paper, paper, stone, paper, stone, paper. Two paper in a row at
// the top is the same pattern /services opens on: the questions are the
// page's content and they read best on the same ground the headline sits on.
// Two groups of questions then alternate, and the page closes the way the
// other two do, with a stone band and then the centred CTA on paper.
//
// WHAT THE REBUILD DELETED:
//
//   <PageHeader title="FAQs" />   a 1,600px stock photograph behind the word
//                                 "FAQs", with two empty flanking divs. The
//                                 component stays for /privacy_policy and
//                                 /terms_and_conditions, which are not
//                                 rebuilt. Reasoning in ./intro/index.js.
//   div.faqs                      a flat run of fourteen <h3> and <p> pairs
//                                 inside one bare div, styled from
//                                 assets/styles/faqs.css with no token in
//                                 it. There was no section, no rhythm, no
//                                 measure and no disclosure: the page looked
//                                 like a different website from the two
//                                 either side of it.
//
// assets/styles/faqs.css STAYS, even though this page no longer uses a line
// of it: /privacy_policy and /terms_and_conditions both render
// `div.faqs` and are the next two pages to rebuild. It is misnamed rather
// than dead, and renaming it is their job, not this one's.
//
// WHAT THE REBUILD CORRECTED, and the three contradictions it refused to
// resolve, are at the top of ./questions/faqs.js. Read that header before
// changing a word of the copy.
//
// THE STRUCTURED DATA IS PART OF THIS PAGE. SeoHelper#seo_faq renders an
// FAQPage block and app/views/gwmc/index.html.haml renders it on this path
// and no other, so SeoHelper::FAQ is this page's sixth and seventh answer as
// far as Google is concerned. Google asks that FAQPage markup match visible
// page text, so a change to an answer here is a change there: the two were
// corrected together.
export const FAQsPage = React.memo(() => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="home">
      <Helmet title="Mobile car wash FAQs | GoWashMyCar" />

      <Intro />
      <Questions />
      <AskAndCta />
    </div>
  )
})
